import React, { useEffect, useState } from "react";
import "./blogCard.css";
import { auth, db } from "../../firebase";
import { toast, Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const DashboardBlogCard = ({ setsize }) => {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [idArr, setIdArr] = useState([]);
  const [isDeleted, setIsDeleted] = useState(false);

  const fetchBlogs = async () => {
    try {
      const response = db
        .collection("blogs")
        .doc(auth.currentUser?.uid)
        .collection("blog");
      const data = await response.get();

      const fetchedBlogs = [];
      const fetchedIds = [];

      data.docs.forEach((doc) => {
        fetchedBlogs.push(doc.data());
        fetchedIds.push(doc.id);
      });

      setBlogs(fetchedBlogs);
      setIdArr(fetchedIds);
      setsize(Math.ceil(fetchedBlogs.length / 3));
    } catch (error) {
      console.error("Error fetching blogs:", error);
      toast.error("Failed to fetch blogs.");
    }
  };

  useEffect(() => {
    fetchBlogs();
    return () => {
      setBlogs([]);
      setIdArr([]);
    };
  }, []);

  const handleDelete = (blogId) => {
    try {
      db.collection("blogs")
        .doc(auth.currentUser?.uid)
        .collection("blog")
        .doc(blogId)
        .delete();
      
      setBlogs((prevBlogs) => prevBlogs.filter((_, idx) => idArr[idx] !== blogId));
      setIdArr((prevIds) => prevIds.filter((id) => id !== blogId));

      toast.success("Blog Deleted!");
    } catch (error) {
      console.error("Error deleting blog:", error);
      toast.error("Failed to delete blog.");
    }
  };

  return (
    <div>
      <Toaster
        position="top-center"
        reverseOrder={false}
        gutter={8}
        toastOptions={{
          duration: 5000,
          style: {
            background: "#FA4C86",
            color: "#fff",
          },
          success: {
            duration: 3000,
            theme: {
              primary: "#FA4C86",
              secondary: "black",
            },
          },
        }}
      />
      <div className={`courses-container ${isDeleted ? "hidden" : ""}`}>
        {blogs.map((item, idx) => (
          <div key={idArr[idx]} className="course" style={{ width: "90%" }}>
            <div className="course-preview">
              <h6>{item.Date}</h6>
              <h2>{item.title}</h2>
            </div>
            <div className="course-info">
              <div className="progress-container"></div>
              <h6>{item.text.slice(0, 150)}</h6>
              <button
                className="btnii"
                onClick={() => handleDelete(idArr[idx])}
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardBlogCard;
